import { gql } from '@apollo/client'

export const SHOP_APPLIED_DISCOUNT_CODE_FRAGMENT = gql`
  fragment ShopAppliedDiscountCode on ShopAppliedDiscountCode {
    id
    limitForUser
    maxDiscountMoneyFormatted
    minOrderMoney
    minOrderMoneyFormatted
    name
    discountMoneyFormatted
    discountType
    percent
    isValid
  }
`
